import React from 'react';

// @material-ui/icons
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import FastForwardIcon from '@material-ui/icons/FastForward';

import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';

export const SwipableTracksControls = ({
  approve,
  nextSong,
  inFavorites,
  canGoBack,
  previousSong,
  toggleIsFavorite,
}) => (
  <GridContainer justify='center'>
    <GridItem xs={1} />
    <GridItem xs={2}>
      {canGoBack && <FastRewindIcon fontSize='large' onClick={previousSong} />}
    </GridItem>
    {!inFavorites && (
      <GridItem xs={3}>
        <div
          style={{
            width: '65px',
            height: '65px',
            background: 'white',
            borderRadius: '50%',
            padding: '10px',
            position: 'relative',
            marginTop: '-17px',
          }}
        >
          <CloseIcon
            style={{
              color: 'red',
              fontSize: '45px',
              fontWeight: 'bold',
            }}
            onClick={nextSong}
          />
        </div>
      </GridItem>
    )}
    {!inFavorites && (
      <GridItem xs={3}>
        <div
          style={{
            width: '65px',
            height: '65px',
            background: 'white',
            borderRadius: '50%',
            padding: '10px',
            position: 'relative',
            marginTop: '-17px',
          }}
        >
          <DoneIcon
            style={{
              color: 'green',
              fontSize: '45px',
              fontWeight: 'bold',
            }}
            onClick={approve}
          />
        </div>
      </GridItem>
    )}
    <GridItem xs={inFavorites ? 6 : 2}>
      <FavoriteIcon
        style={{
          color: inFavorites ? 'red' : 'black',
          fontSize: inFavorites ? '50px' : '30px',
        }}
        onClick={toggleIsFavorite}
      />
    </GridItem>
    {inFavorites && (
      <GridItem xs={2}>
        <FastForwardIcon fontSize='large' onClick={nextSong} />
      </GridItem>
    )}
    <GridItem xs={1} />
  </GridContainer>
);

export default SwipableTracksControls;
